module.exports = __webpack_public_path__ + "img/ios_digitalprev.ecfc349e.png";